import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';

import LoginForm from 'features/login/component/loginForm';
import { hideLoginModal, loginUser } from 'features/login/store/login.action';
import { showRegisterdModal, showRegisterModalStep2 } from 'features/registration/store/register.action';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'redux';
import FormModal from 'shared/components/form/formModal';
import { APP_URL } from 'shared/constants/common';
import { CouponState, State } from 'shared/interface';
import { createIsActionLoadingSelector } from 'shared/store/loading.selectors';
import { decryptData, isLoggedin } from 'shared/util/utility';
import './styles.scss';

interface MapStateProps {
	loading: boolean;
	registerModalState: boolean;
}

interface DispatchProps {
	loginUser: (loginActionData: any, coupon: CouponState) => Promise<any>;
	hideLoginModal: () => void;
	showRegisterModal: () => void;
	showRegisterModalStep2: () => void;
}

interface LoginModalProps extends MapStateProps, DispatchProps, RouteComponentProps {}

const LoginModal = (props: LoginModalProps) => {
	const loginOpen = useSelector<State, boolean>((state) => state.login.loginModalOpen);
	const dispatch = useDispatch();

	if (loginOpen === false) {
		return null;
	}
	if (isLoggedin()) {
		return <></>;
	}

	const handleClose = () => {
		dispatch(hideLoginModal());
	};

	const signInData = decryptData(localStorage.getItem('keepSignedIn'));

	const loginFormInitialValues = {
		email: signInData.login || '',
		password: signInData.password || '',
		keepSignedIn: signInData.keepSignedIn || false,
	};

	if (isLoggedin()) {
		return <></>;
	}

	return (
		<FormModal open={loginOpen} close={handleClose}>
			<LoginForm
				actionType={''}
				onIconClick={props.hideLoginModal}
				initialValues={loginFormInitialValues}
				loginUser={props.loginUser}
				handleNavTab={() => {
					props.history.push(APP_URL.forgotPassword);
				}}
			/>
		</FormModal>
	);
};

const selectIsActionLoading = createIsActionLoadingSelector('LOGIN');

const mapStateToProps = (state: State): MapStateProps => ({
	...state.login,
	loading: selectIsActionLoading(state),
	registerModalState: state.registerModal.step1RegisterModalOpen,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>): DispatchProps => ({
	loginUser: (loginActionData: any, coupon: CouponState) => dispatch(loginUser(loginActionData, coupon)),
	hideLoginModal: () => dispatch(hideLoginModal()),
	showRegisterModal: () => dispatch(showRegisterdModal()),
	showRegisterModalStep2: () => dispatch(showRegisterModalStep2()),
});

export default connect<MapStateProps, DispatchProps, Record<string, unknown>, State>(mapStateToProps, mapDispatchToProps)(withRouter(LoginModal));
